<mat-sidenav-container [hasBackdrop]="false"
                       (backdropClick)="handleGracefulClose()"
                       class="body-1-regular-1">
  <mat-sidenav #sidenavRight mode="over" position="end"
               class="admin-feature-sidenav-no-scrollbar"
               [fixedInViewport]="true"
               [fixedTopGap]="56"
               [fixedBottomGap]="0"
               [opened]="false"
               (keydown.escape)="handleGracefulClose()"
               disableClose
               style="width: 500px">
    @if (selectedRoleGroupRow) {
      <app-crud-table
        title='MEMBER ROLES'
        longDescription='The following roles are members of this group. All users that are granted access to this group will get access to all the following roles'
        [modelType]="memberRolesModelType"
        [loading$]="loading$"
        [tableData]="selectedRoleGroupRow.memberRoles"
        [displayColumns]="memberRolesModelTypeDisplayCols"
        filterType="NONE"
      ></app-crud-table>

      @if (addGrantRequest) {
        <app-crud-item
          title="Add user to role group"
          longDescription="Grant access to a user, this will grant the user access to the role as well as to the offering and property. Note: After granting the user access, the system will automatically send a notification to the user with their login details. The user will have to reset their password in order to log in for the first time."
          submitMode="LOCAL"
          [(data)]="addGrantRequest"
          [modelType]="addGrantModelType"
          [enableCancelButton]="true"
          (onFormSubmitted)="handleAddUserGrantFormSubmission($event)"
          (updateCanceled)="handleUpdateCanceled($event)"
        >
        </app-crud-item>
      } @else if (grantedUsers) {
        <app-crud-table
          title='GRANTS'
          subTitle='Users with access'
          [modelType]="grantsModelType"
          [loading$]="loading$"
          [tableData]="grantedUsers"
          [additionalActions]="grantsAdditionalActions"
          (rowSelected)="grantedUserRowSelected($event)"
          [updatedRow]="addGrantRequestUpdated"
        >
        </app-crud-table>
      }
    } @else {
      No data selected
    }
  </mat-sidenav>


  <mat-sidenav-content>
    <kit-page-header [section]="'Offering grants'"
                     [title]="'View and manage user roles and permissions'"
                     [fullWidthDescription]="true"
                     [backgroundWhite]="false"
                     [description]="'Manage users that have been granted access to a role group. The system has a number of role groups, that are organized into specific module groups. These module groups correspond directly to the menu structure a logged in user will see for the specified offering.'"
    ></kit-page-header>

    @if (loading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="fx-col fx-gap-20">
      <div class="fx-row fx-gap-20">
        <button (click)="toggleAddGrantsDialog()" class="button-action" mat-flat-button
                [disabled]="!!(loading$ | async)">
          <div class="button-text">Add grant</div>
        </button>
      </div>

      @for (moduleGroup of roleGroupModules; track moduleGroup) {
        <app-crud-table
          [title]="getModuleDef(moduleGroup.moduleGroupCode)?.title ?? 'ROLE GROUPS'"
          [subTitle]="getModuleDef(moduleGroup.moduleGroupCode)?.description ?? null"
          [modelType]="principleRoleGroupModelType"

          [tableData]="moduleGroup.principleRoleGroups"
          [interruptPendingChanges]="pendingChanges"
          (rowSelected)="principleRoleGroupsRowSelected($event)"
        ></app-crud-table>

        <mat-divider></mat-divider>
      }
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
